// extracted by mini-css-extract-plugin
module.exports = {"toast-container":"toast-container_toast-container__1JyXa","placeHolderShimmer":"toast-container_placeHolderShimmer__s2Xaq"};